const cookieConsent = () => {
  return '/cookie-consent'
}

export default cookieConsent